export interface DocumentProcessingRequest {
  AccountHolders: AccountHolder[];
  Attributes: Attributes;
  EncompassClientId: string;
  EncompassInstanceId: string;
  MonthsOfStatements: number;
  RequestNotes: string;
  RequestType: string;
  TpoContactEmail: string;
  WorkflowType: string;

  EncompassUserId: string | null;
  EncompassUserEmail: string | null;
  EncompassUserFirstName: string | null;
  EncompassUserLastName: string | null;
  EncompassUserPhoneNumber: string | null;
}


export interface AccountHolder {
  email: string;
  firstName: string;
  lastName: string;
  businessName?: string;
  businessType?: string;
  businessTypeOther?: string | null;
  ownershipPercentage?: number | null;
  address: string;
  birthDate: string;
  city: string;
  state: string;
  zipCode: string;
  phoneNumber: string;
  last4Ssn: string;
}

export interface Attributes {
  AccountType: string;
}

/** The `Attributes.AccountType` code for a Business Account review. */
export const BUSINESS_ACCOUNT_TYPE = 'BUSINESS';

/** The `Attributes.AccountType` code for a Personal Account review. */
export const PERSONAL_ACCOUNT_TYPE = 'PERSONAL';

/** The lowest Business Ownership % Deephaven considers on a Business Account review. */
export const MINIMUM_OWNERSHIP_PERCENTAGE = 25;